/** Set in createApp() so Pinia stores can navigate without a stale default router. */
export const routerHolder = { router: null };
